const states = [
  { value: 'US-AL', label: 'Alabama', abbreviation: 'AL' },
  { value: 'US-AK', label: 'Alaska', abbreviation: 'AK' },
  { value: 'US-AZ', label: 'Arizona', abbreviation: 'AZ' },
  { value: 'US-AR', label: 'Arkansas', abbreviation: 'AR' },
  { value: 'US-CA', label: 'California', abbreviation: 'CA' },
  { value: 'US-CO', label: 'Colorado', abbreviation: 'CO' },
  { value: 'US-CT', label: 'Connecticut', abbreviation: 'CT' },
  { value: 'US-DE', label: 'Delaware', abbreviation: 'DE' },
  { value: 'US-FL', label: 'Florida', abbreviation: 'FL' },
  { value: 'US-GA', label: 'Georgia', abbreviation: 'GA' },
  { value: 'US-HI', label: 'Hawaii', abbreviation: 'HI' },
  { value: 'US-ID', label: 'Idaho', abbreviation: 'ID' },
  { value: 'US-IL', label: 'Illinois', abbreviation: 'IL' },
  { value: 'US-IN', label: 'Indiana', abbreviation: 'IN' },
  { value: 'US-IA', label: 'Iowa', abbreviation: 'IA' },
  { value: 'US-KS', label: 'Kansas', abbreviation: 'KS' },
  { value: 'US-KY', label: 'Kentucky', abbreviation: 'KY' },
  { value: 'US-LA', label: 'Louisiana', abbreviation: 'LA' },
  { value: 'US-ME', label: 'Maine', abbreviation: 'ME' },
  { value: 'US-MD', label: 'Maryland', abbreviation: 'MD' },
  { value: 'US-MA', label: 'Massachusetts', abbreviation: 'MA' },
  { value: 'US-MI', label: 'Michigan', abbreviation: 'MI' },
  { value: 'US-MN', label: 'Minnesota', abbreviation: 'MN' },
  { value: 'US-MS', label: 'Mississippi', abbreviation: 'MS' },
  { value: 'US-MO', label: 'Missouri', abbreviation: 'MO' },
  { value: 'US-MT', label: 'Montana', abbreviation: 'MT' },
  { value: 'US-NE', label: 'Nebraska', abbreviation: 'NE' },
  { value: 'US-NV', label: 'Nevada', abbreviation: 'NV' },
  { value: 'US-NH', label: 'New Hampshire', abbreviation: 'NH' },
  { value: 'US-NJ', label: 'New Jersey', abbreviation: 'NJ' },
  { value: 'US-NM', label: 'New Mexico', abbreviation: 'NM' },
  { value: 'US-NY', label: 'New York', abbreviation: 'NY' },
  { value: 'US-NC', label: 'North Carolina', abbreviation: 'NC' },
  { value: 'US-ND', label: 'North Dakota', abbreviation: 'ND' },
  { value: 'US-OH', label: 'Ohio', abbreviation: 'OH' },
  { value: 'US-OK', label: 'Oklahoma', abbreviation: 'OK' },
  { value: 'US-OR', label: 'Oregon', abbreviation: 'OR' },
  { value: 'US-PA', label: 'Pennsylvania', abbreviation: 'PA' },
  { value: 'US-RI', label: 'Rhode Island', abbreviation: 'RI' },
  { value: 'US-SC', label: 'South Carolina', abbreviation: 'SC' },
  { value: 'US-SD', label: 'South Dakota', abbreviation: 'SD' },
  { value: 'US-TN', label: 'Tennessee', abbreviation: 'TN' },
  { value: 'US-TX', label: 'Texas', abbreviation: 'TX' },
  { value: 'US-UT', label: 'Utah', abbreviation: 'UT' },
  { value: 'US-VT', label: 'Vermont', abbreviation: 'VT' },
  { value: 'US-VA', label: 'Virginia', abbreviation: 'VA' },
  { value: 'US-WA', label: 'Washington', abbreviation: 'WA' },
  { value: 'US-WV', label: 'West Virginia', abbreviation: 'WV' },
  { value: 'US-WI', label: 'Wisconsin', abbreviation: 'WI' },
  { value: 'US-WY', label: 'Wyoming', abbreviation: 'WY' },
  { value: 'US-DC', label: 'District of Columbia', abbreviation: 'DC' },
  { value: 'US-AS', label: 'American Samoa', abbreviation: 'AS' },
  { value: 'US-GU', label: 'Guam', abbreviation: 'GU' },
  { value: 'US-MP', label: 'Northern Mariana Islands', abbreviation: 'MP' },
  { value: 'US-PR', label: 'Puerto Rico', abbreviation: 'PR' },
  { value: 'US-UM', label: 'United States Minor Outlying Islands', abbreviation: 'UM' },
  { value: 'US-VI', label: 'U.S. Virgin Islands', abbreviation: 'VI' },
  { value: 'AU-ACT', label: 'Australian Capital Territory', abbreviation: 'ACT' },
  { value: 'AU-NSW', label: 'New South Wales', abbreviation: 'NSW' },
  { value: 'AU-NT', label: 'Northern Territory', abbreviation: 'NT' },
  { value: 'AU-QLD', label: 'Queensland', abbreviation: 'QLD' },
  { value: 'AU-SA', label: 'South Australia', abbreviation: 'SA' },
  { value: 'AU-TAS', label: 'Tasmania', abbreviation: 'TAS' },
  { value: 'AU-VIC', label: 'Victoria', abbreviation: 'VIC' },
  { value: 'AU-WA', label: 'Western Australia', abbreviation: 'WA' },
  { value: 'CA-AB', label: 'Alberta', abbreviation: 'AB' },
  { value: 'CA-BC', label: 'British Columbia', abbreviation: 'BC' },
  { value: 'CA-MB', label: 'Manitoba', abbreviation: 'MB' },
  { value: 'CA-NB', label: 'New Brunswick', abbreviation: 'NB' },
  { value: 'CA-NL', label: 'Newfoundland and Labrador', abbreviation: 'NL' },
  { value: 'CA-NS', label: 'Nova Scotia', abbreviation: 'NS' },
  { value: 'CA-NT', label: 'Northwest Territories', abbreviation: 'NT' },
  { value: 'CA-NU', label: 'Nunavut', abbreviation: 'NU' },
  { value: 'CA-ON', label: 'Ontario', abbreviation: 'ON' },
  { value: 'CA-PE', label: 'Prince Edward Island', abbreviation: 'PE' },
  { value: 'CA-QC', label: 'Quebec', abbreviation: 'QC' },
  { value: 'CA-SK', label: 'Saskatchewan', abbreviation: 'SK' },
  { value: 'CA-YT', label: 'Yukon', abbreviation: 'YT' },
];

export default states;